/* eslint-disable import/no-named-as-default */
import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';

Vue.use(Vuex);

// TODO please look at the original from the salesforce feature and add in new mutations and state as apporpriate

export default new Vuex.Store({
  state: {
    isMobile: window.screen.availWidth <= process.env.VUE_APP_MOBILE_WIDTH,
    braintreeOptions: {
      useFeature: false,
      tokenApi: '',
      paymentApi: '',
    },
    selectedView: 0,
    sections: [],
    personalDetailsJson: '',
    correspondenceJson: '',
    sectionOffset: 0,
    inviewElement: null,
    areas: [
      {
        name: 'UnderstandingYou', progressValue: 0, stepValue: 0, label: 'Understanding You', icon: 'account', visible: true, clickable: undefined,
      },
      {
        name: 'PersonalDetails', progressValue: 25, stepValue: 1, label: 'Your Details', icon: 'account-key', visible: true, clickable: undefined,
      },
      {
        name: 'Address', progressValue: 50, stepValue: 2, label: 'Address', icon: 'account-plus', visible: true, clickable: undefined,
      },
      {
        name: 'Insurance', progressValue: 0, stepValue: -1, label: 'Insurance', icon: 'account-alert', visible: false, clickable: undefined,
      },
      {
        name: 'Payment', progressValue: 75, stepValue: 3, label: 'Payment', icon: 'account-convert', visible: true, clickable: undefined,
      },
      {
        name: 'Confirmation',
        progressValue: 100,
        stepValue: 4,
        label: 'Confirmation',
        icon: 'account-multiple-check',
        visible: true,
        clickable: undefined,
      }],
    currentArea: null,
    application: null,
    paymentOption: null,
    cardPaymentResult: null,
    dataLayer: null,
    understandingYouOptions: {
      MembershipTypes: [],
      Institutions: [],
      Sectors: [],
      PrimaryOccupations: [],
      EmploymentStatuses: [],
      DegreeStartDates: [],
      DegreeEndDates: [],
      QualificationDates: [],
      TraineeAssessment: [],
      AdditionalRoles: [],
    },
    paymentOptions: [
      {
        PaymentMethod: 'Card',
        FeeInfo: '',
        DiscountInfo: '',
        NoOfPayments: 0,
        PaymentType: '',
        TotalAmountDue: '£0.00',
        DiscFullYearFee: '£0.00',
        FrequencyAmount: '£0.00',
        FullYearPayment: '£0.00',
      }, {
        PaymentMethod: 'Monthly',
        FeeInfo: '',
        DiscountInfo: '',
        NoOfPayments: 0,
        PaymentType: '',
        TotalAmountDue: '£0.00',
        DiscFullYearFee: '£0.00',
        FrequencyAmount: '£0.00',
        FullYearPayment: '£0.00',
      }, {
        PaymentMethod: 'Annual',
        FeeInfo: '',
        DiscountInfo: '',
        NoOfPayments: 0,
        PaymentType: '',
        TotalAmountDue: '£0.00',
        DiscFullYearFee: '£0.00',
        FrequencyAmount: '£0.00',
        FullYearPayment: '£0.00',
      }],
    paymentOptionsInfo: null,
    pliMembershipCategories: ['Member', 'Foundation Trainee'],
    nonWorkingStatuses: ['Maternity Leave', 'Long-term Illness', 'Career Break'],
  },
  mutations,
  getters,
  actions,
  modules: {
  },
});
